import store from '../../store/store';

export default (to, from, next) => {
	if (!store.getters['auth/loggedIn']) {
		store.dispatch('auth/logout');
		return next({path: '/login', query: { fromPath: to.fullPath } });		
	}

	return next();
}